<template>
  <div
    class="w-full bg-gradient-to-b from-[#05215e] to-[#1c3689] 2xl:bg-gradient-to-b 2xl:from-[#05225E] 2xl:to-[#183883]"
  >
    <div class="w-full max-w-screen-2xl m-auto">
      <div class="flex flex-col md:flex-row">
        <!--courses-->
        <div
          class="bg-[#05215e] md:bg-gradient-to-r md:from-[#0F2377] md:to-[#304AB7] 2xl-bg-gradient-to-r 2xl:from-[#05215e] 2xl:to-[#05215e] pt-5 md:py-10 lg:min-h-[600px] md:w-[30%] lg:w-[25%] xl:w-[20%] 2xl:w-[19%]"
        >
          <h3 class="text-white text-lg text-center py-3 hidden md:block">
            Our Leading Offerings
          </h3>
          <div
            class="flex gap-4 md:flex-wrap overflow-x-scroll md:overflow-hidden md:justify-center scrollBehaviour md:px-[1rem]"
          >
            <a
              href="/online-mba/finance"
              title="MBA in Finance"
              class="py-2 px-2"
            >
              <div class="flex flex-col gap-1 w-max items-center">
                <div
                  class="rounded-full border-[#F8C300] border-[1px] w-[3.5rem] h-[3.5rem] md:w-[4rem] md:h-[4rem] 2xl:w-[4.5rem] 2xl:h-[4.5rem] bg-white flex justify-center items-center"
                >
                  <div class="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px]">
                    <!-- <picture>
                      <source
                        media="(min-width:650px)"
                        srcset="@/assets/home/mbaInFinance.svg"
                        alt="mba in finance information"
                        fetchpriority="low"
                      />

                      <img
                        src="@/assets/home/mbaInFinance_mob.svg"
                        alt="mba in finance information"
                        class="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px] object-contain"
                        fetchpriority="low"
                      />
                    </picture> -->
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 32 32"
                      version="1.1"
                    >
                      <defs>
                        <clipPath id="clip1">
                          <path
                            d="M 12 0 L 31.757812 0 L 31.757812 20 L 12 20 Z M 12 0 "
                          />
                        </clipPath>
                        <clipPath id="clip2">
                          <path
                            d="M 0 0 L 31.757812 0 L 31.757812 31.757812 L 0 31.757812 Z M 0 0 "
                          />
                        </clipPath>
                        <clipPath id="clip3">
                          <path
                            d="M 0 2 L 20 2 L 20 31.757812 L 0 31.757812 Z M 0 2 "
                          />
                        </clipPath>
                      </defs>
                      <g id="surface1">
                        <g clip-path="url(#clip1)" clip-rule="nonzero">
                          <path
                            style="
                              fill: none;
                              stroke-width: 1;
                              stroke-linecap: butt;
                              stroke-linejoin: miter;
                              stroke: rgb(0%, 10.980392%, 32.941176%);
                              stroke-opacity: 1;
                              stroke-miterlimit: 4;
                            "
                            d="M -268.243875 -268.243469 L -281.333719 -268.243469 L -281.333719 -281.333312 C -274.111063 -281.313781 -268.263406 -275.466125 -268.243875 -268.243469 Z M -268.243875 -268.243469 "
                            transform="matrix(1,0,0,1,299.072,282.263)"
                          />
                        </g>
                        <g clip-path="url(#clip2)" clip-rule="nonzero">
                          <path
                            style="
                              fill: none;
                              stroke-width: 1;
                              stroke-linecap: butt;
                              stroke-linejoin: miter;
                              stroke: rgb(0%, 10.980392%, 32.941176%);
                              stroke-opacity: 1;
                              stroke-miterlimit: 4;
                            "
                            d="M -268.243469 -266.974719 L -255.220031 -266.974719 C -255.216125 -259.767688 -261.040344 -253.916125 -268.243469 -253.888781 C -275.462219 -253.912219 -281.305969 -259.755969 -281.333312 -266.974719 C -281.302062 -274.177844 -275.4505 -280.005969 -268.243469 -279.998156 Z M -268.243469 -266.974719 "
                            transform="matrix(1,0,0,1,282.263,284.713)"
                          />
                        </g>
                        <g clip-path="url(#clip3)" clip-rule="nonzero">
                          <path
                            style="
                              fill: none;
                              stroke-width: 1;
                              stroke-linecap: butt;
                              stroke-linejoin: miter;
                              stroke: rgb(0%, 10.980392%, 32.941176%);
                              stroke-opacity: 1;
                              stroke-miterlimit: 4;
                            "
                            d="M 0.00159375 -377.557781 L 9.208625 -386.768719 L 0.00159375 -395.979656 "
                            transform="matrix(1,0,0,1,4.807,404.507)"
                          />
                        </g>
                      </g>
                    </svg>
                  </div>
                </div>
                <div
                  class="text-white pt-1 font-medium text-sm w-[5rem] 2xl:text-lg"
                >
                  MBA in Finance
                </div>
              </div>
            </a>
            <a
              href="/online-mba/human-resources-management"
              title="MBA in Human Resource"
              class="py-2 px-2"
            >
              <div class="flex flex-col gap-1 w-max items-center">
                <div
                  class="rounded-full border-[#F8C300] border-[1px] w-[3.5rem] h-[3.5rem] md:w-[4rem] md:h-[4rem] 2xl:w-[4.5rem] 2xl:h-[4.5rem] bg-white flex justify-center items-center"
                >
                  <!-- <div
                    class="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px] object-contain"
                  > -->
                  <div>
                    <picture>
                      <source
                        media="(min-width:650px)"
                        srcset="@/assets/home/mbaInHr.svg"
                        alt="mba in human resource information"
                        fetchpriority="low"
                      />

                      <img
                        src="@/assets/home/mbaInHr_mob.svg"
                        alt="mba in human resource information"
                        class="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px] object-contain"
                        fetchpriority="low"
                      />
                    </picture>
                  </div>
                </div>
                <div
                  class="text-white pt-1 font-medium text-sm w-[5rem] 2xl:text-lg"
                >
                  MBA in Human Resource
                </div>
              </div>
            </a>
            <a
              href="/online-mba/hr-finance"
              title="MBA in HR & Finance"
              class="py-2 px-2"
            >
              <div class="flex flex-col w-max gap-1 items-center">
                <div
                  class="rounded-full border-[#F8C300] border-[1px] w-[3.5rem] h-[3.5rem] md:w-[4rem] md:h-[4rem] 2xl:w-[4.5rem] 2xl:h-[4.5rem] bg-white flex justify-center items-center"
                >
                  <!-- <div
                    class="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px] object-contain"
                  > -->
                  <div>
                    <picture>
                      <source
                        media="(min-width:650px)"
                        srcset="@/assets/home/mbaInGm.svg"
                        alt="mba in hr & finance information"
                        fetchpriority="low"
                      />
                      <img
                        src="@/assets/home/mbaInGm_mob.svg"
                        alt="mba in hr & finance information"
                        class="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px] object-contain"
                        fetchpriority="low"
                      />
                    </picture>
                  </div>
                </div>
                <div
                  class="text-white pt-1 font-medium text-sm w-[5rem] 2xl:text-lg"
                >
                  MBA in HR & Finance
                </div>
              </div>
            </a>
            <a
              href="/online-mca/computer-science-and-it"
              title="MCA in Computer Science"
              class="py-2 px-2"
            >
              <div class="flex flex-col gap-1 w-max items-center">
                <div
                  class="rounded-full border-[#F8C300] border-[1px] w-[3.5rem] h-[3.5rem] md:w-[4rem] md:h-[4rem] 2xl:w-[4.5rem] 2xl:h-[4.5rem] bg-white flex justify-center items-center"
                >
                  <!-- <div
                    class="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px] object-contain"
                  > -->
                  <div>
                    <picture>
                      <source
                        media="(min-width:650px)"
                        srcset="@/assets/home/mcaInCS.svg"
                        alt="mca in computer science information"
                        fetchpriority="low"
                      />

                      <img
                        src="@/assets/home/mcaInCS_mob.svg"
                        alt="mca in computer science information"
                        class="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px] object-contain"
                        fetchpriority="low"
                      />
                    </picture>
                  </div>
                </div>
                <div
                  class="text-white pt-1 font-medium text-sm w-[5rem] 2xl:text-lg"
                >
                  MCA in Computer Science
                </div>
              </div>
            </a>
            <a
              href="/online-mca/data-analytics"
              title="MCA in Data Analytics"
              class="py-2 px-2"
              bg-lime-300
            >
              <div class="flex flex-col gap-1 w-max items-center">
                <div
                  class="rounded-full border-[#F8C300] border-[1px] w-[3.5rem] h-[3.5rem] md:w-[4rem] md:h-[4rem] 2xl:w-[4.5rem] 2xl:h-[4.5rem] bg-white flex justify-center items-center"
                >
                  <!-- <div class="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px]"> -->
                  <div>
                    <picture>
                      <source
                        media="(min-width:650px)"
                        srcset="@/assets/home/mcaInAI.svg"
                        alt="mca in data analytics information"
                        fetchpriority="low"
                      />

                      <img
                        src="@/assets/home/mcaInAI_mob.svg"
                        alt="mca in data analytics information"
                        class="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px] object-contain"
                        fetchpriority="low"
                      />
                    </picture>
                  </div>
                </div>
                <div
                  class="text-white pt-1 font-medium text-sm w-[5rem] 2xl:text-lg"
                >
                  MCA in Data Analytics
                </div>
              </div>
            </a>

            <a
              href="/online-mca/cyber-security"
              title="MCA in Cyber Security"
              class="py-2 px-2"
            >
              <div class="flex flex-col gap-1 w-max items-center">
                <div
                  class="rounded-full border-[#F8C300] border-[1px] w-[3.5rem] h-[3.5rem] md:w-[4rem] md:h-[4rem] 2xl:w-[4.5rem] 2xl:h-[4.5rem] bg-white flex justify-center items-center"
                >
                  <div
                    class="w-[32px] h-[32px] lg:w-[40px] lg:h-[40px] object-contain items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      viewBox="0 0 33 36"
                      version="1.1"
                    >
                      <g id="surface1">
                        <path
                          style="
                            fill: none;
                            stroke-width: 1;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                            stroke: rgb(0%, 10.980392%, 32.941176%);
                            stroke-opacity: 1;
                            stroke-miterlimit: 4;
                          "
                          d="M 176.001217 149.118974 L 189.029293 149.118974 L 189.029293 158.890133 L 176.001217 158.890133 Z M 179.255123 149.118974 L 179.255123 143.257971 C 179.255123 141.459469 180.716061 139.999508 182.51318 139.999508 C 184.314449 139.999508 185.771236 141.459469 185.771236 143.257971 L 185.771236 149.118974 "
                          transform="matrix(0.941176,0,0,0.923077,-155.980235,-119.749846)"
                        />
                        <path
                          style="
                            fill: none;
                            stroke-width: 1;
                            stroke-linecap: round;
                            stroke-linejoin: round;
                            stroke: rgb(0%, 10.980392%, 32.941176%);
                            stroke-opacity: 1;
                            stroke-miterlimit: 4;
                          "
                          d="M 72.28418 58.432292 C 62.817139 56.54069 56.002197 48.22526 55.998047 38.568359 L 55.998047 26.512044 L 56.55835 26.512044 C 62.456055 26.512044 68.113037 24.171875 72.28418 19.999349 C 76.455322 24.171875 82.112305 26.512044 88.01416 26.512044 L 88.570312 26.512044 L 88.570312 38.568359 C 88.570312 48.22526 81.755371 56.54069 72.28418 58.432292 Z M 72.28418 48.661133 L 72.28418 45.406901 "
                          transform="matrix(0.941176,0,0,0.923077,-52.235294,-18)"
                        />
                      </g>
                    </svg>
                  </div>
                </div>
                <div
                  class="text-white pt-1 font-medium text-sm w-[5rem] 2xl:text-lg"
                >
                  MCA in Cyber Security
                </div>
              </div>
            </a>
          </div>
        </div>
        <!--courses-->
        <!--header carousel-->
        <div
          class="bg-gradient-to-b from-[#05215e] to-[#1c3689] 2xl:bg-gradient-to-b 2xl:from-[#05225E] 2xl:to-[#183883] min-h-[600px] w-full md:w-[70%] lg:w-[75%] xl:w-[80%] 2xl:w-[81%] rounded-b-2xl md:rounded-b-none md:py-10"
        >
          <div class="bannerCarousel py-10 lg:py-0 h-full">
            <!-- first banner      -->
            <div
              class="!flex !flex-col !items-center !justify-center lg:!flex-row-reverse lg:h-[500px]"
            >
              <picture>
                <source
                  media="(min-width:650px)"
                  srcset="@/assets/home/banners/Banner1-desktop.webp"
                  alt="desktop_banner"
                  fetchpriority="high"
                />

                <img
                  src="@/assets/home/banners/Banner1-mobile.webp"
                  alt="mob_banner"
                  class="w-[282px] h-[281px] object-contain lg:w-[418px] lg:h-[410px]"
                  fetchpriority="high"
                />
              </picture>

              <div class="">
                <h1
                  class="text-white m-auto font-bold text-lg w-[15rem] md:mx-[10px] my-[1rem] md:text-2xl lg:text-3xl xl:text-4xl md:w-[17rem] lg:w-[22.75rem] xl:w-[35rem] text-center lg:text-start"
                >
                  <span class="text-yellow-500">Earn an Online Degree</span>
                  <span> from the</span>
                  <br />
                  <span>comfort of your home!</span>
                </h1>
                <div
                  class="mb-1 md:mb-3 md:ml-3 text-left flex flex-col gap-2 pt-3"
                >
                  <!-- Admissions closing soon! -->
                  <!-- <p class="text-md lg:text-xl text-white">
                    Admission Closing:
                    <span class="text-yellow-500 font-semibold"
                      >March 28th, 2025</span
                    >
                  </p> -->
                  <p class="text-md lg:text-xl text-white">
                    <a
                      href="/master-business-administration-online-degree"
                      target="self"
                      title="master business administration online-degree information"
                    >
                      MBA
                    </a>
                    <span class="text-yellow-500">|</span>
                    <a
                      href="/masters-computer-application-online-degree"
                      target="self"
                      title="masters computer application online degree information"
                    >
                      MCA
                    </a>
                    <span class="text-yellow-500">|</span>
                    <a
                      href="/master-of-commerce-online-degree"
                      target="self"
                      title="master of commerce online degree information"
                    >
                      M.Com
                    </a>
                    <!-- <span class="text-yellow-500">|</span>
                    <a
                      href="/master-of-arts-online-degree"
                      target="self"
                      title="master of arts online degree information"
                    >
                      MA
                    </a> -->
                    <span class="text-yellow-500">|</span>
                    <a
                      href="/bachelor-of-business-administration-online-degree"
                      target="self"
                      title="bachelor of business administration online degree information"
                    >
                      BBA
                    </a>
                    <span class="text-yellow-500">|</span>
                    <a
                      href="/bachelor-of-commerce-online-degree"
                      target="self"
                      title="bachelor of commerce online degree information"
                    >
                      B.Com
                    </a>
                    <span class="text-yellow-500">|</span>
                    <a
                      href="/bachelor-of-computer-application-online-degree"
                      target="self"
                      title="bachelor computer application online degree information"
                    >
                      BCA
                    </a>
                  </p>
                </div>
                <div class="text-center lg:text-start">
                  <!-- <button
                    class="bg-[#f8c300] rounded-full py-2 px-10 font-bold mb-2 w-max md:ml-2"
                    @click="handleApplyNowClick"
                  >
                    Enroll Now
                  </button> -->
                  <a href="https://application.onlinejain.com/" target="_blank"
                    ><button
                      class="bg-[#f8c300] rounded-full py-2 px-10 font-bold mb-2 w-max md:ml-2"
                    >
                      Enroll Now
                    </button></a
                  >
                </div>
              </div>
            </div>
            <!-- second banner -->
            <div
              class="!flex !flex-col !items-center !justify-center lg:!flex-row-reverse lg:h-[500px]"
            >
              <picture>
                <source
                  media="(min-width:650px)"
                  srcset="@/assets/home/banners/JO-Homepage-Desktop-banner.webp"
                  alt="desktop_banner"
                  loading="lazy"
                  decoding="async"
                />

                <img
                  src="@/assets/home/banners/JO-Homepage-Mobile-banner.webp"
                  alt="mob_banner"
                  class="w-[282px] h-[281px] object-contain lg:w-[418px] lg:h-[410px]"
                  loading="lazy"
                  decoding="async"
                />
              </picture>

              <div class="">
                <h2
                  class="text-white m-auto font-bold text-lg w-[15rem] md:mx-[10px] my-[1rem] md:text-2xl lg:text-3xl xl:text-4xl md:w-[17rem] lg:w-[22.75rem] xl:w-[35rem] text-center lg:text-start"
                >
                  <span class="text-yellow-500"
                    >Over 30 Years of Legacy and Counting...</span
                  ><br /><span class="text-sm md:text-lg"
                    >Be part of JAIN Online—where dreams take flight, careers
                    are shaped, and success stories are written.</span
                  >
                </h2>

                <div class="text-center lg:text-start">
                  <div>
                    <!-- <button
                      class="bg-[#f8c300] rounded-full py-2 px-10 font-bold mb-2 w-max md:ml-2"
                      @click="handleApplyNowClick"
                    >
                      Apply Now
                    </button> -->
                    <a
                      href="https://application.onlinejain.com/"
                      target="_blank"
                      ><button
                        class="bg-[#f8c300] rounded-full py-2 px-10 font-bold mb-2 w-max md:ml-2"
                      >
                        Apply Now
                      </button></a
                    >
                  </div>
                </div>
              </div>
            </div>
            <!-- third banner  -->
            <!-- <div
              class="!flex !flex-col !items-center !justify-center lg:!flex-row-reverse lg:h-[500px]"
            >
              <picture>
                <source
                  media="(min-width:650px)"
                  srcset="@/assets/home/banners/Banner3-icon-desktop.webp"
                  alt="desktop_banner"
                  loading="lazy"
                  decoding="async"
                />

                <img
                  src="@/assets/home/banners/Banner3-icon-mobile.webp"
                  alt="mob_banner"
                  class="w-[282px] h-[281px] object-contain lg:w-[418px] lg:h-[410px]"
                  loading="lazy"
                  decoding="async"
                />
              </picture>

              <div class="">
                <h2
                  class="text-white m-auto font-bold text-lg w-[15rem] md:mx-[10px] my-[1rem] md:text-2xl lg:text-3xl xl:text-4xl md:w-[17rem] lg:w-[22.75rem] xl:w-[35rem] text-center lg:text-start"
                >
                  Unleash Your Coding Skills at <br />
                  <span class="font-bold text-[#f8c300]"
                    >The Power of PyHackathon!</span
                  >
                </h2>

                <div class="text-center lg:text-start">
                  <a href="https://forms.gle/v9sHiq5KgZXmrg7e8" target="_blank"
                    ><button
                      class="bg-[#f8c300] rounded-full py-2 px-10 font-bold mb-2 w-max md:ml-2"
                    >
                      Register Now
                    </button></a
                  >
                </div>
              </div>
            </div> -->
          </div>
        </div>
        <!--header carousel-->
      </div>
    </div>
    <!-- <ApplyView v-if="showApplyForm" @close="closeForm" /> -->
    <!--popup for download Ebook-->
    <!-- <EbookView v-show="popup" @close-button="this.popup = false" /> -->
    <!--popup for download Ebook-->
    <IframePopup v-if="showApplyForm" @close="showApplyForm = false" />
  </div>
</template>

<script>
import $ from "jquery";
import "slick-carousel";
import ApplyView from "@/components/ApplyformView.vue";
import IframePopup from "@/components/IframeView.vue";

//import EbookView from "@/components/EbookView.vue";
export default {
  name: "BannerView",

  components: {
    ApplyView,
    IframePopup,
  },

  data() {
    return {
      popup: false,
      showApplyForm: false,
    };
  },
  beforeMount() {
    const elementToRemoveDes = document.querySelector(".bannerCarousel");

    if (elementToRemoveDes) {
      elementToRemoveDes.remove();
    }
  },
  async mounted() {
    $(`.bannerCarousel`).slick({
      infinite: true,
      autoplay: true,
      prevArrow: null,
      nextArrow: null,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      dotsClass: "slickdotsbannerbanner",
    });
  },
  methods: {
    handleApplyNowClick() {
      // Push data to dataLayer
      dataLayer.push({
        event: "Apply Online Initiated",
        Attribute: {
          CTA: "Apply Now",
          "Section Name": "Homepage Banner",
        },
      });

      // Open the ApplyView modal
      // window.open("https://application.onlinejain.com/", "_blank");
      this.showApplyForm = true;
    },
    closeForm() {
      // Close the ApplyView modal
      this.showApplyForm = false;
    },
  },
};
</script>

<style></style>
